import { render } from "./MosaicoSalasView.vue?vue&type=template&id=cb417d82&scoped=true"
import script from "./MosaicoSalasView.vue?vue&type=script&lang=js"
export * from "./MosaicoSalasView.vue?vue&type=script&lang=js"

import "./MosaicoSalasView.vue?vue&type=style&index=0&id=cb417d82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb417d82"]])

export default __exports__